import FarloUiLightbox from './vendors/farlo-ui-lightbox';

import { farloUiMobileSlider } from './components/footer/flickity-mobile.js';
import { farloUiMobileSliderCast } from './components/footer/flickity-mobile-cast.js';
import { ticker } from './components/footer/ticker.js';
import { addScrolledClass } from './components/footer/addScrolledClass.js';
import { mobileSearchButton } from './components/footer/mobileSearchButton.js';


((document, window, history) => {
	const pushState = history.pushState;

	function menuItemHasChildren() {
		// Get all the parent li elements with the class '.menu-item-has-children'
		const parentItems = document.querySelectorAll('.menu-item-has-children');

		// Add click event listeners to the first child <a> tag of each parent li element
		parentItems.forEach(parentItem => {
			const firstAnchor = parentItem.querySelector('a:first-child');
			let isClicked = false;

			firstAnchor.addEventListener('click', function (event) {
				// Check if it's the first click
				if (!isClicked) {
					// Prevent the default action of the anchor element
					event.preventDefault();

					// Add a class to the parent li element
					parentItem.classList.add('menu-item-has-children--active');

					// Update the click status
					isClicked = true;
				}
			});
		});
	}

	function toggleCalendarArchive() {
		var calendarArchive = document.querySelector('.farlo-calendar-archive');
		var calendarButton = document.querySelector('.farlo-calendar-archive__button');
		var eventArchive = document.querySelector('.farlo-loop-product');
		var eventSearch = document.querySelector('.archive-search');
		if (calendarArchive.classList.contains('farlo-calendar-archive--active')) {
			calendarArchive.classList.remove('farlo-calendar-archive--active');
			calendarButton.innerHTML = '<svg viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path d="M5.27 0c.343 0 .625.281.625.625V2.5h7.5V.625a.626.626 0 0 1 1.25 0V2.5h1.25c1.378 0 2.5 1.121 2.5 2.5v12.5c0 1.379-1.122 2.5-2.5 2.5h-12.5a2.502 2.502 0 0 1-2.5-2.5V5c0-1.379 1.12-2.5 2.5-2.5h1.25V.625c0-.344.28-.625.625-.625Zm11.875 7.5h-15v10c0 .691.558 1.25 1.25 1.25h12.5c.69 0 1.25-.559 1.25-1.25v-10Zm-1.25-3.75h-12.5c-.692 0-1.25.559-1.25 1.25v1.25h15V5c0-.691-.56-1.25-1.25-1.25Z" fill="#fff"/></g><defs><clipPath id="a"><path fill="#fff" transform="translate(.895)" d="M0 0h17.5v20H0z"/></clipPath></defs></svg> View Event Calendar';
			eventArchive.classList.remove('mobile-hidden');
			eventSearch.classList.remove('mobile-hidden');
		} else {
			calendarArchive.classList.add('farlo-calendar-archive--active');
			calendarButton.innerHTML = '<svg viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path d="M5.27 0c.343 0 .625.281.625.625V2.5h7.5V.625a.626.626 0 0 1 1.25 0V2.5h1.25c1.378 0 2.5 1.121 2.5 2.5v12.5c0 1.379-1.122 2.5-2.5 2.5h-12.5a2.502 2.502 0 0 1-2.5-2.5V5c0-1.379 1.12-2.5 2.5-2.5h1.25V.625c0-.344.28-.625.625-.625Zm11.875 7.5h-15v10c0 .691.558 1.25 1.25 1.25h12.5c.69 0 1.25-.559 1.25-1.25v-10Zm-1.25-3.75h-12.5c-.692 0-1.25.559-1.25 1.25v1.25h15V5c0-.691-.56-1.25-1.25-1.25Z" fill="#fff"/></g><defs><clipPath id="a"><path fill="#fff" transform="translate(.895)" d="M0 0h17.5v20H0z"/></clipPath></defs></svg> Hide Event Calendar';
			eventArchive.classList.add('mobile-hidden');
			eventSearch.classList.add('mobile-hidden');
		}
	}




	function activateDetailsOverlay() {
		document.addEventListener('click', (event) => {
			const button = event.target.closest('.details--button');
			if (button) {
				const overlay = button.querySelector('.col-details__overlay');
				overlay.classList.add('col-details__overlay--active');

				const siteDiv = button.closest('.site');
				siteDiv.classList.add('overlay--active');
			}
		});
	}

	function deactivateDetailsOverlay() {
		document.addEventListener('click', (event) => {
			const overlay = event.target.closest('.col-details__overlay');
			if (overlay) {
				const content = overlay.querySelector('.col-details__content');

				if (!content.contains(event.target) || event.target.classList.contains('col-details__content--close-button')) {
					overlay.classList.remove('col-details__overlay--active');

					const siteDiv = overlay.closest('.site');
					siteDiv.classList.remove('overlay--active');
				}
			}
		});
	}

	function genericLightbox() {
		var toggleButtons = document.querySelectorAll(".farlo-ui-lightbox-generic__toggle");
		// Loop through each toggle button and add a click event listener
		toggleButtons.forEach(function (button) {
			button.addEventListener("click", function (e) {
				e.preventDefault();
				// Get the value of the "data-target" attribute
				var targetId = button.getAttribute("data-target");

				// Find the corresponding div element by ID
				var targetDiv = document.querySelector(targetId);
				document.body.classList.add('body--farlo-ui-lightbox-open');

				// Check if the target div exists
				if (targetDiv) {
					// Set the style of the target div to "display: block"
					targetDiv.style.display = "flex";
					targetDiv.classList.add('farlo-ui-lightbox--active');
				}
			});
		});

		document.querySelectorAll('.farlo-ui-lightbox__close-button').forEach((_sel) => {
			_sel.addEventListener('click', (e) => {
				e.preventDefault();
				document.body.classList.remove('body--farlo-ui-lightbox-open');

				e.currentTarget.parentNode.classList.remove('farlo-ui-lightbox--active');
			});
		});

	}
	function castLightbox() {
		// Get all elements with the class "farlo-ui-lightbox-cast__toggle"
		var toggleButtons = document.querySelectorAll(".farlo-ui-lightbox-cast__toggle");

		// Loop through each toggle button and add a click event listener
		toggleButtons.forEach(function (button) {
			button.addEventListener("click", function () {
				// Get the value of the "data-target" attribute
				var targetId = button.getAttribute("data-target");

				// Find the corresponding div element by ID
				var targetDiv = document.querySelector(targetId);
				document.body.classList.add('body--farlo-ui-lightbox-open');

				// Check if the target div exists
				if (targetDiv) {
					// Set the style of the target div to "display: block"
					targetDiv.style.display = "flex";
					targetDiv.classList.add('farlo-ui-lightbox--active');
				}
			});
		});

		document.querySelectorAll('.farlo-ui-lightbox__close-button').forEach((_sel) => {
			_sel.addEventListener('click', (e) => {
				e.preventDefault();
				document.body.classList.remove('body--farlo-ui-lightbox-open');
			});
		});

	}






	function fixSubmenuOnScroll() {
		const submenuDiv = document.querySelector('.single--event__submenu');
		const site = document.querySelector(".site")
		const lockSubmenu = () => {
			if (window.pageYOffset > document.querySelector('.single--event__feature').offsetHeight) {
				submenuDiv.classList.add('single--event__submenu--fixed');
				site.classList.add('event__submenu--active');
			} else {
				submenuDiv.classList.remove('single--event__submenu--fixed');
				site.classList.remove('event__submenu--active');
			}
		}
		_farlo.handlers.scroll.push(lockSubmenu);
		lockSubmenu()
	}

	function handleHeaderTransparency() {
		const site = document.querySelector(".site")
		var mastheadFrontpage = document.querySelector('.masthead-frontpage');

		var mastheadRect = mastheadFrontpage.getBoundingClientRect();
		var isVisible = mastheadRect.bottom > 0 && mastheadRect.top < window.innerHeight;

		if (isVisible) {
			site.classList.add('above-fold');
		} else {
			site.classList.remove('above-fold');
		}
	}





	// default cookie compliance script
	function cookieCompliance() {
		if (document.querySelector('.farlo-ui-biscuit-banner__button')) {
			document.querySelector('.farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');
			});
		}
	}

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active'); document.querySelector('.site-navigation').classList.toggle('site-navigation__nav--active');
			document.body.classList.toggle('site-navigation__nav--open');
		});
	}

	function isTouchDevice() {
		return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
	}

	function toggleActiveClass() {
		var div = document.getElementsByClassName("rank-math-list-item");

		for (var i = 0; i < div.length; i++) {
			div[i].addEventListener("click", function () {
				if (this.classList.contains("rank-math-list-item--active")) {
					this.classList.remove("rank-math-list-item--active");
				} else {
					this.classList.add("rank-math-list-item--active");
				}
			});
		}
	}

	function scrollXBreadcrumbs() {
		var objDiv = document.querySelector(".farlo-breadcrumbs");
		objDiv.scrollLeft = objDiv.scrollWidth;
	}

	function toggleDirections() {
		var div = document.getElementsByClassName("method-list__item");

		for (var i = 0; i < div.length; i++) {
			div[i].addEventListener("click", function () {
				if (this.classList.contains("method-list__item--active")) {
					this.classList.remove("method-list__item--active");
					// Collapse the accordion smoothly
					var content = this.querySelector(".method__instructions");
					content.style.height = "0";
				} else {
					// Expand the accordion smoothly
					this.classList.add("method-list__item--active");
					var content = this.querySelector(".method__instructions");
					content.style.height = content.scrollHeight + "px";
				}
			});
		}
	}


	function initializeImageAccordion(accordionID) {
		var imageAccordion = document.querySelector(accordionID);

		if (!imageAccordion) {
			return; // Exit the function if the imageAccordion element is not found
		}

		var carouselImages = imageAccordion.querySelectorAll('.image-accordion-images .image-accordion-image');
		var carouselCaptions = imageAccordion.querySelectorAll('.image-accordion-content .image-accordion-captions .image-accordion-caption');

		// Set the first image and caption as active
		if (carouselImages.length > 0 && carouselCaptions.length > 0) {
			carouselImages[0].classList.add('active');
			carouselCaptions[0].classList.add('active');
		}

		// Handle automatic scrolling of carousel
		var currentIndex = 0;
		var intervalTime = 3000; // Adjust this value to control the scroll speed
		var interval;

		function startInterval() {
			interval = setInterval(function () {
				currentIndex++;
				if (currentIndex >= carouselImages.length) {
					currentIndex = 0;
				}
				updateActiveItem(currentIndex);
			}, intervalTime);
		}

		function stopInterval() {
			clearInterval(interval);
		}

		// Update active item based on index
		function updateActiveItem(index) {
			carouselImages.forEach(function (image) {
				image.classList.remove('active');
			});
			carouselCaptions.forEach(function (caption) {
				caption.classList.remove('active');
			});

			if (carouselImages[index] && carouselCaptions[index]) {
				carouselImages[index].classList.add('active');
				carouselCaptions[index].classList.add('active');
			}
		}

		// Handle caption click event
		carouselCaptions.forEach(function (caption, index) {
			caption.addEventListener('click', function (event) {
				event.preventDefault();
				updateActiveItem(index);
				stopInterval();
			});
		});

		// Start the interval initially
		startInterval();
	}


	function createLinks() {
		// Get the ul element with class 'farlo-page-menu'
		const menu = document.querySelector('.farlo-page-menu');

		// Check if the menu exists
		if (menu) {
			// Array of ID-link mappings
			const idLinks = [
				{ id: 'about', label: 'About' },
				{ id: 'reviews', label: 'Reviews' },
				{ id: 'ticket-information', label: 'Event & Ticket Information' },
				{ id: 'booking', label: 'Performances' },
				{ id: 'membership', label: 'Membership' },
				{ id: 'bar', label: 'Bar' },
			];

			// Create list elements and links for existing IDs
			const listElements = idLinks.reduce((elements, { id, label }) => {
				if (document.querySelector(`#${id}`)) {
					const li = document.createElement('li');
					const a = document.createElement('a');
					a.href = `#${id}`;
					a.textContent = label;
					li.appendChild(a);
					elements.push(li);
				}
				return elements;
			}, []);

			// Append list elements to the menu
			listElements.forEach(li => {
				menu.appendChild(li);
			});
			scrollLinks();

		}
	}




	function addFooterCtaClass() {
		var footerCta = document.querySelector(".footer-cta");

		if (isElementVisible(footerCta)) {
			footerCta.classList.add('footer-cta--active');
		} else {
			footerCta.classList.remove('footer-cta--active');
		}

		// Add event listener to call the function when the user scrolls
		history.pushState = function (state) {
			if (typeof history.onpushstate === 'function') {
				history.onpushstate({ state });
			}
			return pushState.apply(history, arguments);
		};
	}


	function hideButton() {
		const btn = document.querySelector(".button[href='#booking']");
		const calendar = document.querySelector(".farlo-cal-date--active");
		if (calendar && isElementVisible(calendar)) {
			btn.classList.add("hidden");
		} else {
			btn.classList.remove("hidden");
		}

	}


	function timelineScroll() {
		var items = document.querySelectorAll('.timeline li');
		var timelineHeight = document.querySelector('.timeline ul').offsetHeight;
		var greyLine = document.querySelector('.default-line');
		var lineToDraw = document.querySelector('.draw-line');

		// Sets the height that the greyLine (.default-line) should be according to `.timeline ul` height
		greyLine.style.height = timelineHeight + 130 + 'px';


		// Run this function only if draw line exists on the page
		if (lineToDraw) {
			window.addEventListener('scroll', function () {
				// Need to constantly get '.draw-line' height to compare against '.default-line'

				var greyLineHeight = greyLine.offsetHeight;
				var windowDistance = window.pageYOffset || document.documentElement.scrollTop;
				var windowHeight = window.innerHeight / 2;
				var timelineDistance = document.querySelector('.timeline').offsetTop;

				if (windowDistance >= timelineDistance - windowHeight) {
					var line = windowDistance - timelineDistance + windowHeight;

					if (line <= greyLineHeight) {
						lineToDraw.style.height = line + 20 + 'px';
					}
				} else {
					lineToDraw.style.height = greyLineHeight
				}

				// This takes care of adding the class in-view to the li:before items
				var bottom = lineToDraw.offsetTop + lineToDraw.offsetHeight;
				items.forEach(function (item) {
					var circlePosition = item.offsetTop;

					if (bottom > circlePosition) {
						item.classList.add('in-view');
					} else {
						item.classList.remove('in-view');
					}
				});
			});
		}
	}

	function isElementVisible(element) {
		const rect = element.getBoundingClientRect();
		const windowHeight = window.innerHeight || document.documentElement.clientHeight;
		const windowWidth = window.innerWidth || document.documentElement.clientWidth;

		return (
			rect.top < windowHeight &&
			rect.bottom > 0 &&
			rect.left < windowWidth &&
			rect.right > 0
		);
	}

	function handleImageCtaBlock() {
		const imageCtaBlocks = document.querySelectorAll('.image-cta-block');

		const observerOptions = {
			root: null, // Use the viewport as the root
			threshold: 0.1 // Trigger the callback when 10% of the element is visible
		};

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const imageCtaBlock = entry.target;

				if (document.querySelector('.run-animation-once')) {
					if (entry.isIntersecting) {
						imageCtaBlock.classList.add('image-cta-block--active');
					}
				} else {

					if (entry.isIntersecting) {
						imageCtaBlock.classList.add('image-cta-block--active');
					} else {
						imageCtaBlock.classList.remove('image-cta-block--active');
					}
				}
			});
		}, observerOptions);

		imageCtaBlocks.forEach((imageCtaBlock) => {
			observer.observe(imageCtaBlock);
		});
	}


	// Get the heights of the fixed divs

	function menuLightbox() {
		const div = document.createElement('div');
		const divInner = document.createElement('div');
		const divInnerContent = document.createElement('div');
		const closeButton = document.createElement('button');
		const iframe = document.createElement('iframe');
		div.className = 'farlo-ui-lightbox';
		divInner.className = 'farlo-ui-lightbox__inner';
		divInnerContent.className = 'farlo-ui-lightbox__inner-content';
		closeButton.className = 'farlo-ui-lightbox__close-button';

		div.innerHTML = '';

		div.appendChild(closeButton);
		div.appendChild(divInner);
		divInner.appendChild(divInnerContent);
		divInnerContent.appendChild(iframe);

		document.querySelectorAll('.menu-buttons .farlo-ui-lightbox__trigger').forEach((_sel) => {
			_sel.closest('.menus').appendChild(div);

			_sel.addEventListener('click', (e) => {
				e.preventDefault();

				if (window.innerWidth <= 1024 && isTouchDevice()) {
					window.open(e.currentTarget.href, '_blank');
					return;
				}

				document.body.classList.add('body--farlo-ui-lightbox-open');

				_sel.closest('.menus').querySelector('.farlo-ui-lightbox').classList.add('farlo-ui-lightbox--active');

				iframe.src = e.currentTarget.href;
			});
		});

		document.querySelectorAll('.farlo-ui-lightbox__close-button').forEach((_sel) => {
			_sel.addEventListener('click', (e) => {
				e.preventDefault();
				document.body.classList.remove('body--farlo-ui-lightbox-open');

				e.currentTarget.parentNode.classList.remove('farlo-ui-lightbox--active');
			});
		});
	}

	function iframeLightbox() {
		const div = document.createElement('div');
		const divInner = document.createElement('div');
		const divInnerContent = document.createElement('div');
		const closeButton = document.createElement('button');
		const iframe = document.createElement('iframe');
		div.className = 'farlo-ui-lightbox';
		divInner.className = 'farlo-ui-lightbox__inner';
		divInnerContent.className = 'farlo-ui-lightbox__inner-content';
		closeButton.className = 'farlo-ui-lightbox__close-button';

		div.innerHTML = '';

		div.appendChild(closeButton);
		div.appendChild(divInner);
		divInner.appendChild(divInnerContent);
		divInnerContent.appendChild(iframe);

		document.querySelectorAll('.iframe__button.farlo-ui-lightbox__trigger').forEach((_sel) => {
			_sel.closest('.iframe__container').appendChild(div);

			_sel.addEventListener('click', (e) => {
				e.preventDefault();



				document.body.classList.add('body--farlo-ui-lightbox-open');

				_sel.closest('.iframe__container').querySelector('.farlo-ui-lightbox').classList.add('farlo-ui-lightbox--active');

				iframe.src = e.currentTarget.href;
			});
		});

		document.querySelectorAll('.farlo-ui-lightbox__close-button').forEach((_sel) => {
			_sel.addEventListener('click', (e) => {
				e.preventDefault();
				document.body.classList.remove('body--farlo-ui-lightbox-open');

				e.currentTarget.parentNode.classList.remove('farlo-ui-lightbox--active');
			});
		});
	}

	function toggleFarloCalDateShow() {
		var showMoreButtons = document.querySelectorAll('.farlo-cal-date__show-more');

		showMoreButtons.forEach(function (button) {
			button.addEventListener('click', function () {
				var parentDateElement = button.closest('.farlo-cal-date');
				if (parentDateElement) {
					parentDateElement.classList.toggle('farlo-cal-date--show');
				}
			});
		});
	}

	setTimeout(toggleFarloCalDateShow, 3000); // Wait for 3 seconds before calling the function

	function formPushState() {
		if (window.location.search) {
			const newUrl = window.location.origin + window.location.pathname;
			window.history.pushState({}, document.title, newUrl);
		}
	}

	function adjustPageMarginTop() {
		var headerHeight = document.querySelector('.site-header').offsetHeight;
		//document.querySelector('.site-main').style.marginTop = headerHeight + 'px';
	}

	function hiddenForm() {


		var anchorLinks = document.querySelectorAll('a');
		anchorLinks.forEach(function (link) {
			link.addEventListener('click', function (event) {
				if (link.hash === '#' + anchorLink) {
					event.preventDefault();
					openLightbox(formID);
				}
			});
		});
	}

	function openLightbox(formID) {

		var formLightboxModal = document.createElement('div');
		formLightboxModal.className = 'form-lightbox-modal';

		var formLightboxContent = document.createElement('div');
		formLightboxContent.className = 'form-modal-content';

		var formContainer = document.querySelector('.hidden-form-block');
		formLightboxContent.appendChild(formContainer.cloneNode(true));

		formLightboxModal.appendChild(formLightboxContent);
		document.body.appendChild(formLightboxModal);

		formLightboxModal.addEventListener('click', function (event) {
			if (event.target === formLightboxModal) {
				document.body.removeChild(formLightboxModal);
			}
		});
	}


	_farlo.handlers.load.push(adjustPageMarginTop);
	//   window.addEventListener('load', function() {
	// 	adjustPageMarginTop();
	//   });
	_farlo.handlers.resize.push(adjustPageMarginTop);

	//   window.addEventListener('resize', function() {
	// 	adjustPageMarginTop();
	//   });

	document.addEventListener('DOMContentLoaded', () => {

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}

		if (document.querySelector('.site-main')) {
			addScrolledClass();
		}

		//if (document.querySelector('.cards-slider__enable')) {
		document.querySelectorAll('.cards-slider__enable').forEach((_sel) => {
			farloUiMobileSlider(_sel);
		});
		//}

		document.querySelectorAll('.cast-slider__enable').forEach((_sel) => {
			farloUiMobileSliderCast(_sel);
		});

		if (document.querySelector('.site-marquee__ticker')) {
			document.querySelectorAll('.site-marquee__ticker').forEach((_sel) => {
				ticker(_sel);
			});
		}

		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.menu-item-has-children')) {
			menuItemHasChildren();
		}


		if (document.querySelector('.farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		if (document.querySelector('.hidden-form-block')) {
			hiddenForm();
		}

		if (document.querySelector('.rank-math-list-item')) {
			toggleActiveClass();
		}

		if (document.querySelector('.method-list')) {
			toggleDirections();
		}
		if (document.querySelector('.masthead-frontpage')) {
			handleHeaderTransparency();
			_farlo.handlers.scroll.push(handleHeaderTransparency);
		}

		if (document.querySelector('.single--event__submenu')) {
			fixSubmenuOnScroll();
		}

		if (document.querySelector('.farlo-breadcrumbs')) {
			scrollXBreadcrumbs();
		}

		if (document.querySelector('.footer-cta')) {
			addFooterCtaClass();
			_farlo.handlers.scroll.push(addFooterCtaClass);

		}

		if (document.querySelector('.farlo-page-menu')) {
			createLinks();
		}

		if (document.querySelector('.details--button')) {
			activateDetailsOverlay();
			deactivateDetailsOverlay();
		}

		if (document.querySelector('.filter-form')) {
			formPushState();
		}
		if (document.querySelector('.farlo-ui-lightbox-cast__toggle')) {
			castLightbox();
		}

		if (document.querySelector('.image-cta-block')) {
			handleImageCtaBlock();
		}

		if (document.querySelector('.timeline')) {
			timelineScroll();
		}

		if (document.querySelector('.menu-buttons')) {
			menuLightbox();
		}
		if (document.querySelector('.iframe__container')) {
			iframeLightbox();
		}

		if (document.querySelector("#booking")) {
			hideButton();
			_farlo.handlers.scroll.push(hideButton);
		}
		if (document.querySelector('.farlo-calendar-archive__button')) {
			var button = document.querySelector('.farlo-calendar-archive__button');
			button.addEventListener('click', toggleCalendarArchive);
		}

		if (document.querySelector('.image-accordion-block')) {
			var accordionBlock = document.querySelector('.image-accordion-block');
			var accordionID = '#' + accordionBlock.id;
			initializeImageAccordion(accordionID);
		}

		genericLightbox();
	});

	function scrollLinks() {
		const offsetHeight = parseInt(document.documentElement.style.getPropertyValue('--header-height'), 10) + parseInt(document.documentElement.style.getPropertyValue('--sub-header-height'), 10);
		document.querySelectorAll("a").forEach(elem => {
			if (elem.href) {
				if (_farlo.helpers.urls.isHash(elem)) {
					elem.addEventListener("click", (e) => {
						e.preventDefault();
						let url = elem.href.split("#");
						let selector = "#" + url[1];
						if (document.querySelector(selector)) {
							//window.location.hash = selector;
							farlo_red61.tools.pageScroll(selector, 150)
						} else {
							document.location.href = elem.href;
						}
					});
				}
			}
		});
	}
	scrollLinks();

	if (document.location.hash) {
		let url = document.location.href.split("#");
		let selector = "#" + url[1];
		try {
			if (document.querySelector(selector)) {
				pageScroll(selector);
			}
		} catch (ex) {

		}
	}


	var _ukds_signup_form = null;
	var _ukds_signup_id = 'leadgen';


	function _ukdsMcSignup() {


		const signupFields = [
			document.querySelector("#FOOTER_NAME"),
			document.querySelector("#FOOTER_EMAIL"),
		];

		let valid = true;
		for (let _i in signupFields) {
			switch (signupFields[_i].type) {
				case "email":
					if (!_farlo.helpers.validators.email(signupFields[_i].value)) {
						signupFields[_i].classList.add("invalid");
						valid = false;
					} else {
						signupFields[_i].classList.remove("invalid");
					}
					break;
				case "text":
					if (signupFields[_i].value == "") {
						signupFields[_i].classList.add("invalid");
						valid = false;
					} else {
						signupFields[_i].classList.remove("invalid");
					}

					break;

			}

		}
		if (valid) {
			if (_ukds_signup_form) {
				_ukds_signup_form.toggleForm();
			} else {
				_ukds_signup_form = new UKDS_MC({
					"validateFirst": true,
					"formId": _ukds_signup_id,
					"initData": {
						"EMAIL": signupFields[1].value,
						"FNAME": signupFields[0].value,
					}
				});
			}
		}
	}

	function _ukdsMcSignupBlank() {
		if (_ukds_signup_form) {
			_ukds_signup_form.toggleForm();
		} else {
			_ukds_signup_form = new UKDS_MC({
				"formId": _ukds_signup_id,
			});
		}

	}

	function initialiseResyWidget() {
		var buttons = document.querySelectorAll('a[href*="https://resy.com"]');
		// If the button exists, dynamically load the Resy widget script
		var script = document.createElement('script');
		script.src = 'https://widgets.resy.com/embed.js';
		script.async = true;
		//script.onload = initialiseResyWidget;
		document.head.appendChild(script);

		for (var i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener('click', function (e) {
				e.preventDefault();

				// You can replace these values with your actual venueId and apiKey
				var venueId = "74532";
				var apiKey = "lUDCiJ905v5Pv0dq5D3U8DrKlwn4NB4q";

				resyWidget.openModal({
					"venueId": venueId,
					"apiKey": apiKey,
					'replace': 'true'
				});
			}, false);
		}
	}





	document.querySelectorAll(".toggle-mc-form").forEach((_sel) => {
		_sel.addEventListener("click", () => {
			if (_sel.dataset.mc_remindme) {
				document.getElementById("REMINDME").value = _sel.dataset.mc_remindme;
			}
			if (_sel.dataset.prompt) {
				document.getElementById("signup").querySelectorAll(".ukds-mc-tab")[0].querySelector("h3").innerText = _sel.dataset.prompt;
			}
			if (_sel.dataset.success) {
				document.getElementById("signup").querySelectorAll(".ukds-mc-tab")[1].querySelector("p").innerText = _sel.dataset.success;
			}

			_ukdsMcSignupBlank();
		});
	});
	document.addEventListener("click", function (e) {
		if (document.querySelector(".farlo-ui-lightbox--active")) {
			const target = e.target.closest(".toggle-mc-form");
			if (target) {
				if (target.dataset.mc_remindme) {
					document.getElementById("REMINDME").value = target.dataset.mc_remindme;
				}
				if (target.dataset.prompt) {
					document.getElementById("signup").querySelectorAll(".ukds-mc-tab")[0].querySelector("h3").innerText = target.dataset.prompt;
				}
				if (target.dataset.success) {
					document.getElementById("signup").querySelectorAll(".ukds-mc-tab")[1].querySelector("p").innerText = target.dataset.success;
				}
				document.body.classList.remove('body--farlo-ui-lightbox-open');
				target.closest('.farlo-ui-lightbox').classList.remove('farlo-ui-lightbox--active');
				_ukdsMcSignupBlank();
			}


		}

	});


	document.querySelectorAll(".submit-mc-form").forEach((_sel) => {
		_sel.addEventListener("click", () => {
			_ukdsMcSignup();
		});
	});

	const checkInputValue = (_inp) => {
		if (_inp.value) {
			_inp.parentElement.classList.add("form-item-active");
		} else {
			_inp.parentElement.classList.remove("form-item-active");
		}
	}
	document.querySelectorAll(".form-field").forEach((_inp) => {

		_inp.addEventListener("focus", () => {
			_inp.parentElement.classList.add("form-item-active");
		});
		_inp.addEventListener("blur", () => {
			checkInputValue(_inp);
		});
		checkInputValue(_inp);
	});

	document.querySelectorAll(".gfield input").forEach((_inp) => {
		const parentDiv = _inp.closest(".gfield");

		_inp.addEventListener("focus", () => {
			parentDiv.classList.add("form-item-active");
		});

		_inp.addEventListener("blur", () => {
			parentDiv.classList.remove("form-item-active");
			checkInputValue(_inp);
		});

		checkInputValue(_inp);
	});


	function formNumberInputs(_sel) {
		const upButton = document.createElement("button");
		const downButton = document.createElement("button");
		window._farlo.helpers.wrapElement(_sel, document.createElement("div"), "site-form-field__input-number");
		upButton.className = "site-form-field__input-number-button site-form-field__input-number-button--up";
		upButton.innerHTML = "&plus;";
		downButton.className = "site-form-field__input-number-button site-form-field__input-number-button--down";
		downButton.innerHTML = "&minus;";

		_sel.parentNode.appendChild(upButton);
		_sel.parentNode.appendChild(downButton);

		// Set a data-default-step attribute for dynamic validation
		if (!_sel.getAttribute("data-default-step")) {
			_sel.setAttribute("data-default-step", _sel.step);
		}

		// Handle increment button
		upButton.addEventListener("click", (e) => {
			e.preventDefault();
			const input = e.currentTarget.parentNode.querySelector("input");
			input.stepUp(); // Increment the value
			validateQuantity(input); // Validate the new value
			updateCartOrSummary(input); // Add tickets to the basket
		});

		// Handle decrement button
		downButton.addEventListener("click", (e) => {
			e.preventDefault();
			const input = e.currentTarget.parentNode.querySelector("input");

			const value = parseFloat(input.value) || 0;
			const defaultStep = parseFloat(input.getAttribute("data-default-step"));
			const minValue = input.id.endsWith("PLUS") ? defaultStep : 0;

			// Decrement logic
			if (value > minValue || value === 0) {
				input.stepDown(); // Decrement normally
				validateQuantity(input); // Validate the new value
			}

			// Enforce minimum step for PLUS items
			if (value < minValue && value !== 0) {
				input.value = minValue; // Reset to minValue if below threshold
			}

			updateCartOrSummary(input); // Update cart
		});

		// Handle manual input
		_sel.addEventListener("input", (e) => {
			validateQuantity(e.target);
		});

		// Handle "Enter" key to add tickets to the basket
		_sel.addEventListener("keydown", (e) => {
			if (e.key === "Enter") {
				e.preventDefault(); // Prevent default form submission
				validateQuantity(e.target); // Ensure the value is valid
				updateCartOrSummary(e.target); // Add tickets to the basket
			}
		});
	}

	// Helper function to update the cart or summary
	function updateCartOrSummary(input) {
		// Simulate adding tickets based on the input value
		const tickets = parseFloat(input.value) || 0; // Get validated ticket quantity
		console.log(`Adding ${tickets} tickets to the basket`);

		if (window.farlo_red61) {
			if (farlo_params.is_basket) {
				window.farlo_red61.booking.update_cart();
			} else {
				window.farlo_red61.booking.build_summary();
			}
		}
	}


	document.querySelectorAll('input[type="number"]').forEach((_sel) => {
		formNumberInputs(_sel);
	});


	if (document.querySelector('.site-farlo-ui-revolver-carousel')) {
		document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
			_sel.farloUiRevolverCarousel();
		});
	}

	function klaroCookieUpdated() {
		if (typeof klaro !== 'undefined') {
			const dataLayer = window.dataLayer || [];

			window.klaro.exports.getManager().watch({
				update(obj, name, data) {
					if (name === 'saveConsents') {
						dataLayer.push({ 'event': 'klaro-updated' });
					}
				}
			});
		}
	}
	function getCookie(name) {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		if (parts.length === 2) return parts.pop().split(";").shift();
	}

	function displayPopup() {
		var popup = document.querySelector('.popup');

		if (localStorage.getItem('mcPopupCookie') != 'true') {
			window.addEventListener('scroll', function () {
				if (window.scrollY >= 600) {
					_ukdsMcSignupBlank();
					window.removeEventListener('scroll', arguments.callee);
				}
			});

			// Close the popup
			var closeButtons = popup.querySelectorAll('.ukds-mc-close');
			closeButtons.forEach(function (closeButton) {
				closeButton.addEventListener('click', function () {
					localStorage.setItem('mcPopupCookie', 'true');
				});
			});
		}
	}




	function newsletterPopup() {
		_ukdsMcSignupBlank();

		var popup = document.querySelector('.popup');
		if (popup) {
			popup.classList.add('newsletter-page');
			popup.classList.add('site__wrapper');
		}
	}



	window.addEventListener('load', () => {

		// if (document.querySelector('.klaro')) {
		// 	klaroCookieUpdated();
		// }

		if (document.querySelector('.farlo-nav-search__mobile')){
			mobileSearchButton();
		}

		if (document.querySelector('.popup')) {
			displayPopup();
		}

		if (document.querySelector('.site-page__newsletter')) {
			newsletterPopup();
		}

		if (document.querySelector('.resy-button')) {
			initialiseResyWidget();
		}

		if (document.querySelector('.site-farlo-ui-revolver-carousel-slider')) {
			let itemsInView = 3; // default value for items in view

			// Check the screen width
			if (window.innerWidth < 980) {
				itemsInView = 1.5; // set items in view to 1 for screen width below 980px
			}
			document.querySelector('.site-farlo-ui-revolver-carousel-slider').farloUiRevolverCarousel({
				autoplaySpeed: 8000,
				autoplay: true,
				controls: true,
				itemsInView: itemsInView, // set the calculated value based on screen width
				infinite: true,
			});
		}
	});

	if (typeof loadSliderCarousel !== "undefined") {
		_farlo.handlers.load.push(loadSliderCarousel);
	}



	let resizeTimer;
	window.addEventListener("resize", () => {
		document.body.classList.add("resize-animation-stopper");
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			document.body.classList.remove("resize-animation-stopper");
		}, 400);
	});

	_farlo.handlers.init();
})(document, window, history);